import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { NewsDto } from 'src/app/api/models';
import { UserNewsApiService } from 'src/app/api/services';
import { StorageService } from 'src/app/core/services/storage.service';
import { StorageEnums } from 'src/shared/models/enums';
import { CustomSpinnerService } from 'src/shared/services/helpers/custom-spinner.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IconComponent } from "../../../../../shared/components/elements/icon/icon.component";
import { NgIf } from '@angular/common';
import { SafeHtmlPipe } from 'src/shared/pipes/safe-html.pipe';

@Component({
	selector: 'vl-news-details',
	templateUrl: './news-details.page.html',
	styleUrls: ['./news-details.page.scss'],
 imports: [IconComponent, NgIf, SafeHtmlPipe],
})
export class NewsDetailsPage implements OnInit {
	news: NewsDto;
	ready = false;
	imageUlr: SafeResourceUrl;
	@Input() id: number;

	constructor(private modalController: ModalController,
				private spinner: CustomSpinnerService,
				private storage: StorageService,
				private sanitizer: DomSanitizer,
				private newsService: UserNewsApiService) {
		this.spinner.show();
	}

	ngOnInit() {
	}

	ionViewDidEnter() {
		this.getNews(this.id);
	}

	back() {
		this.modalController.dismiss();
	}

	getNews(id) {
		this.newsService.getNews({
			id
		}).subscribe(async r => {
			let lang = await this.storage.getItem(StorageEnums.LANG);
			this.news = r;
			if(r.image) {
				this.getNewsImage(this.id);
			}
			if (lang === 'de') {
				this.news.title = this.news.titleDe;
				this.news.message = this.news.messageDe;
			}
			this.spinner.hide();
			this.ready = true;
		})
	}

	getNewsImage(imgId: number) {
		this.newsService.getNewsImage({
			id: imgId,
			size: 500
		}).subscribe((res) => {
			if (res){
				this.imageUlr = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(res as unknown as Blob));
			}
		}, error => {
			console.log('Image error', error.message);
		});
	}

}
